export { TagSelectComponent } from './tag-select.component';
export { AdTagSelectModule } from './tag-select.module';
